import React from "react";
import { Stack } from "@bookingcom/bui-react";
import { BagPersonalItemIcon, CabinTrolleyIcon, BagHoldIcon, PlaneTicketReturnIcon } from "@bookingcom/bui-assets-react/streamline/index.js";
import { IconWithInclusionType } from "../IconWithInclusionType/index.js";
export const ANCILLARY_TO_ICON_MAP = {
    PERSONAL_ITEM: BagPersonalItemIcon,
    CABIN: CabinTrolleyIcon,
    CHECKED: BagHoldIcon,
    FLEX_TICKET: PlaneTicketReturnIcon
};
export const CardAncillaries = ({ ancillaries, attributes }) => {
    return (React.createElement(Stack, { attributes: attributes, direction: "row", gap: 1 }, ancillaries.map(({ ancillaryType, inclusionType, ariaLabel }) => {
        return (React.createElement(IconWithInclusionType, { icon: ANCILLARY_TO_ICON_MAP[ancillaryType], inclusionType: inclusionType, ariaLabel: ariaLabel, key: ancillaryType }));
    })));
};
